<template>
  <div v-if="value" class="alert-info p-xs">
    <div class="text-primary">
      <i class="fa fa-exclamation-triangle fa-1x"></i> Advanced Search in use, select the same or
      <a  href="/search/"
                    class="text-" ><b>'New search' </b></a>to reset.
    </div>
  </div>
</template>

<style>
</style>
<script>
  export default {

    components: {},
    name: 'AdvancedSearchNotificationBox',
    props: ["value"],
    methods: {
    },
    filters: {},
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/search/AdvancedSearchNotificationBox.vue